<script>
  import MediaQuery from "./MediaQuery.svelte";

  export let query;
  export let alignment = "flex-start";
  export let margin = "0";
  export let justify = "flex-start";
  export let wrap = false;
  export let grow = false;
  export let overflow = "inherit";
</script>

<MediaQuery {query}>
  <div
    class:wrap
    class:grow
    style="align-items: {alignment}; justify-content: {justify};  overflow: {overflow}">
    <slot />
  </div>
  <div
    class="column"
    class:wrap
    class:grow
    slot="else"
    style="align-items: {alignment}; justify-content: {justify}; margin: {margin};">
    <slot />
  </div>
</MediaQuery>

<style>
  div {
    display: flex;
  }
  div > :global(*) {
    flex: 0 0 auto;
  }

  div.column {
    flex-direction: column;
  }
  div.wrap {
    flex-wrap: wrap;
  }

  div.grow {
    height: 100%;
    flex-grow: 1;
    align-items: stretch;
  }
  div.grow > :global(*) {
    flex-shrink: 1;
  }
</style>
